import { useDeviceType } from '@cian/ui-kit';
import { clsx as cx } from 'clsx';
import * as React from 'react';

import * as styles from './Hero.css';

const preview_1_5x = require('../../assets/preview@1_5x.png');
const preview_2x = require('../../assets/preview@2x.png');

export const Hero: React.FC = () => {
  const deviceType = useDeviceType();

  return (
    <div className={cx(styles['container'], styles[`container--${deviceType}`])}>
      <img
        src={preview_1_5x}
        srcSet={`${preview_1_5x},
               ${preview_2x} 2x`}
        className={styles['image']}
        width="257"
        height="220"
        alt=""
      />
    </div>
  );
};
